import React from 'react';
import { useTranslation } from 'react-i18next';

export const DeleteConfirmationModal = ({ closeModal, subject }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    closeModal(true);
  };

  const handleCancel = () => {
    closeModal(false);
  };

  return (
    <div className='modal'>
      <div className='modal-content'>
        <p>
          {t('deleteConfirmationModal.message', { subject: subject })}
        </p>

        <div className='container mg-t-2'>
          <button
            className='mg-r-1 width-100p background-danger'
            onClick={handleConfirm}
          >
            {t('deleteConfirmationModal.deleteButton')}
          </button>
          <button className='width-100p' onClick={handleCancel}>
            {t('deleteConfirmationModal.cancelButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;